import './index.css'

const TransactionItem = props => {
  const {eachTransaction, onDelete} = props
  const {title, amount, type, id} = eachTransaction
  const onDeleteTransaction = () => {
    onDelete(id)
  }

  return (
    <li className="table-header">
      <p className="table-header-cells">{title}</p>
      <p className="table-header-cells">{amount}</p>
      <p className="table-header-cells">{type}</p>
      <button
        type="button"
        className="table-delete-cells"
        onClick={onDeleteTransaction}
      >
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/delete.png"
          alt="delete"
          className="delete-img"
        />
      </button>
    </li>
  )
}

export default TransactionItem
